import { render, staticRenderFns } from "./SetupTestPage1.vue?vue&type=template&id=2f5b45a4&scoped=true&"
import script from "./SetupTestPage1.vue?vue&type=script&lang=js&"
export * from "./SetupTestPage1.vue?vue&type=script&lang=js&"
import style0 from "./SetupTestPage1.vue?vue&type=style&index=0&id=2f5b45a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5b45a4",
  null
  
)

export default component.exports